import {useMemo} from 'react';
import {createColumnHelper, getCoreRowModel, useReactTable} from '@tanstack/react-table';
import {useGetCollabs, type UserType} from 'api/generated';
import {format} from 'date-fns';
import {classNames, getInitials} from 'utils';
import {Avatar} from 'components';

const columnHelper = createColumnHelper<UserType>();

interface IuseTablePeopleProps {
  filter: 'people' | 'invites';
}

const useTablePeople = ({filter}: IuseTablePeopleProps) => {
  const {data: collabsData} = useGetCollabs({}, {query: {enabled: filter === 'people', staleTime: 10 * 1000}});
  const collabs = useMemo(() => collabsData?.data?.data ?? [], [collabsData?.data?.data]);

  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: () => <span>Members</span>,
        cell: info => (
          <div className="flex gap-3 items-center">
            <Avatar imageUrl={info.row.original.imageUrl} alt={info.getValue()} fallback={getInitials(info.getValue())} />
            <div className="flex flex-col">
              <span> {info.getValue()}</span>
              <span className="text-slate-500 dark:text-slate-400">{info.row.original.email}</span>
            </div>
          </div>
        ),
      }),
      columnHelper.accessor('lastActiveAt', {
        header: () => <span>Last Online</span>,
        cell: info => <span>{info.getValue() ? format(new Date(info.getValue()!), 'dd MMM y') : 'Offline'}</span>,
      }),
      columnHelper.accessor('collabProjectsCount', {
        header: () => <span>Collab on</span>,
        cell: info => {
          const noRef = info.getValue() === 0;
          return (
            <span
              className={classNames(!noRef && 'text-primary hover:brightness-120 cursor-pointer')}
              // TODO: Implement this
              onClick={() => !noRef && console.info('show linked projects modal')}>
              {noRef ? '-' : `${info.getValue()} projects`}
            </span>
          );
        },
      }),
    ],
    [],
  );

  const table = useReactTable({
    data: collabs,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return table;
};

export default useTablePeople;
